/**
 * 格式化时间
 *
 * @export
 * @param {*} [date=new Date()] 时间
 * @param {string} [fmt='yyyy-MM-dd HH:mm:ss'] 格式
 * @returns
 */
export function parseTime(date = new Date(), fmt = 'yyyy-MM-dd HH:mm:ss') {
  if (typeof date === 'string') {
    // eslint-disable-next-line no-unused-expressions, no-param-reassign
    date.includes('-') ? date = date.replace(/-/g, '/') : () => { };
  }

  // eslint-disable-next-line no-param-reassign
  date = new Date(date);
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };

  if (/(y+)/.test(fmt)) {
    // eslint-disable-next-line no-param-reassign
    fmt = fmt.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }

  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(fmt)) {
      // eslint-disable-next-line no-param-reassign
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length),
      );
    }
  });

  return fmt;
}

/**
 * 序列化 对象
 *
 * @export
 * @param {string} [query={}]
 * @returns
 */
export function serialize(query = {}) {
  const temp = [];
  /* eslint-disable no-restricted-syntax */
  for (const key in query) {
    if (Object.hasOwnProperty.call(query, key)) {
      const enValue = encodeURIComponent(query[key]);
      temp.push(`${key}=${enValue}`);
    }
  }
  return temp.join('&');
}

export const dataLength = (fData) => {
  let intLength = 0;
  for (let i = 0; i < fData.length; i++) {
    if ((fData.charCodeAt(i) < 0) || (fData.charCodeAt(i) > 255)) intLength += 2;
    else intLength += 1;
  }
  return intLength;
};

// export const strInsert = (str, length, s) => {
//   if (str.length <= length) {
//     return str;
//   }
//   // eslint-disable-next-line no-useless-escape
//   const reg = new RegExp(`\.{1,${length}}`, 'g');
//   const ma = str.match(reg);
//   return `${ma.join(s)}`;
// };

/**
 * 获得中间时间
 *
 *  @export
 * @param {string} [type='hour','day'] 类型
 * @param {string} [startTime='yyyy-MM-dd HH:mm:ss'] 开始时间
 * @param {string} [endTime='yyyy-MM-dd HH:mm:ss'] 开始时间
 *  @param {string} [fmt='yyyy-MM-dd HH:mm:ss'] 格式
 * @returns
 */
export function getMiddleData(type, startTime, endTime, fmt) {
  const midTimeArr = [];

  let dealStartTime = new Date(startTime) * 1;
  const dealEndTime = new Date(endTime) * 1;
  if (type === 'hour') {
    /* eslint-disable no-constant-condition */
    while (true) {
      if (dealStartTime <= dealEndTime) {
        const itemTime = parseTime(dealStartTime, fmt);
        midTimeArr.push(itemTime);
        // debugger;
        dealStartTime += 1 * 60 * 60 * 1000;
      } else {
        break;
      }
    }
  } else if (type === 'day') {
    /* eslint-disable no-constant-condition */
    while (true) {
      if (dealStartTime <= dealEndTime) {
        const itemTime = parseTime(dealStartTime, fmt);
        midTimeArr.push(itemTime);
        // debugger;
        dealStartTime += 24 * 60 * 60 * 1000;
      } else {
        break;
      }
    }
  }
  return midTimeArr;
}

/**
 * @description 动态日期
 */
export function showTimes() {
  // 获取当前日期
  const date = new Date();
  // 获取当前年
  const year = date.getFullYear();
  // 获取当前月
  let month = date.getMonth() + 1;
  if (month < 10) {
    // 月份为个数时，前面补0
    month = `0${month}`;
  }
  // 获取当前日
  let day = date.getDate();
  if (day < 10) {
    // 月份为个数时，前面补0
    day = `0${day}`;
  }
  // 获取当前时
  let hours = date.getHours();
  if (hours < 10) {
    // 月份为个数时，前面补0
    hours = `0${hours}`;
  }
  // 获取当前分
  let minutes = date.getMinutes();
  if (minutes < 10) {
    // 为个数时，前面补0
    minutes = `0${minutes}`;
  }
  // 获取当前秒
  let seconds = date.getSeconds();
  if (seconds < 10) {
    // 为个数时，前面补0
    seconds = `0${seconds}`;
  }

  const wDay = date.getDay();
  const weekday = {
    0: '星期天',
    1: '星期一',
    2: '星期二',
    3: '星期三',
    4: '星期四',
    5: '星期五',
    6: '星期六',
  };
  // 拼接时间
  const datetime = `${year}.${month}.${day} ${weekday[wDay]} ${hours}:${minutes}:${seconds}`;
  // 显示在id为showtimes的容器里
  return datetime;
}
